const Navbar = () => {
    return (  
        <nav className="navbar">
            <div className="links">
                <h1>YAM Blogs</h1>
                <a href="/">Home </a>
                <a href="/posts">New Post</a>
            </div>
        </nav>
    );
}

export default Navbar;